import CustomForm from "../CustomForm";
import ICustomFormSettings from "../ICustomFormSettings";
import {TextareaItem} from "../../model/items/textarea";
import {LabelItem} from "../../model/items/labelItem";

export type Mark = 'positive'|'negative'|'none';

export default abstract class TextHighlighter extends CustomForm {

    protected text: string = '';
    protected textareaItemPositive!: TextareaItem;
    protected textareaItemNegative!: TextareaItem;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        for (const cell of settings.form.grid.cells) {
            for (const cellItem of cell.cellItems) {
                if (cellItem instanceof TextareaItem) {
                    if (!this.textareaItemPositive) {
                        this.textareaItemPositive = cellItem;
                    } else if (!this.textareaItemNegative) {
                        this.textareaItemNegative = cellItem;
                    }
                } else if (cellItem instanceof LabelItem) {
                    this.text = (cellItem.childrenTags[0]?.value || '').trim();
                }
            }
        }
    }


    checkRequirements(): boolean {
        if (!this.textareaItemNegative || !this.textareaItemPositive) {
            console.log("TextHighlighter: Missing textarea. Expect 2 textareas.");
            return false;
        }

        if (!this.text) {
            console.log("TextHighlighter: Missing label for text highlighter.");
            return false;
        }

        return true
    }

}